module.exports = __webpack_public_path__ + "static/img/iphone_mspjhg2.9572940.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/iphone_mspjhg2.png
// module id = FGv0
// module chunks = 0